import { render, staticRenderFns } from "./AscAddPlotToIssueDialog.vue?vue&type=template&id=2b03bc87&"
import script from "./AscAddPlotToIssueDialog.vue?vue&type=script&lang=js&"
export * from "./AscAddPlotToIssueDialog.vue?vue&type=script&lang=js&"
import style0 from "./AscAddPlotToIssueDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports